import { useState, useCallback, useContext, useEffect, useMemo, useRef } from "react";
import { Dropdown, Popover, SideSheet, Tree } from "@douyinfe/semi-ui";
import Link from 'next/link'
import { IndexContext } from "@/stores";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";
import styles from "./styles.module.scss";
import cName from "classnames";

export default ({ }) => {
  const router = useRouter()
  const t = useTranslations();

  const { menuList, menuCurrent, menuParent, webInfo } = useContext(IndexContext);

  const difference = useMemo(() => {
    const exhibition_start_time = Number(webInfo?.find((item: any) => item.code === 'exhibition_start_time')?.content);
    const _difference = String(Math.ceil((exhibition_start_time - Date.now()) / (1000 * 60 * 60 * 24)));
    return _difference
  }, [webInfo]);

  const [isShowMenu, setIsShowMenu] = useState<boolean>(false)

  const changeLang = useCallback((locale: 'cn' | 'en') => {
    router.push(router.asPath, router.asPath, { locale })
  }, [router])
  const getTreeData = useCallback((data: any) => {
    return data?.map((item: any) => {
      return {
        label: item?.name,
        key: String(item?.id),
        children: getTreeData(item?.childlist || []),
        ...item
      }
    })
  }, [])
  const renderFullLabel = useCallback(({ className, data, expandIcon, onClick, onExpand }: any) => {
    const isLeaf = !(data.children && data.children.length);
    return (
      <li className={className} role="treeitem" onClick={isLeaf ? onClick : onExpand}>
        {isLeaf ? null : expandIcon}
        <span>{data?.label}</span>
      </li>
    )
  }, [])
  const gotoPage = useCallback((item: any) => {
    setIsShowMenu(false)
    if (item?._target == "_blank") {
      window.open(item?._href, '_blank');
    } else {
      router.push(item?._href, item?._href, {});
    }
  }, [])

  return (
    <header className={styles.header}>
      <Link href="/">
        <a className={styles.logo}>
          <img src="/image/logo.png" alt="" />
        </a>
      </Link>
      <ul className={styles.menu}>
        {
          menuList?.map((item: any, index: number) => (
            <Popover
              key={index}
              content={
                <ul className={styles.childs}>
                  {
                    item?.childlist?.map((child: any) => (
                      <li key={child?.id}>
                        <Link href={child?._href || '/'}>
                          <a className={styles.child} target={child?._target || '_self'}>{child.name}</a>
                        </Link>
                      </li>
                    ))
                  }
                </ul>
              }
              getPopupContainer={() => document.getElementById(`item_${item?.id}`) as HTMLElement}
              showArrow={true}
              style={{ display: item?.childlist?.length ? 'block' : 'none' }}
              trigger="hover"
            >
              <li id={`item_${item?.id}`} className={cName([styles.item, (item?._href == menuCurrent?._href || item?.id == menuCurrent?.pid) && styles.active])}>
                <Link href={item?._href || '/'}>
                  <a className={styles.link} target={item?._target || '_self'}>{item.name}</a>
                </Link>
                <ul className={styles.childs} style={{ display: 'none' }}>
                  {
                    item?.childlist?.map((child: any) => (
                      <li key={child?.id}>
                        <Link href={child?._href || '/'}>
                          <a className={styles.child} target={child?._target || '_self'}>{child.name}</a>
                        </Link>
                      </li>
                    ))
                  }
                </ul>
              </li>
            </Popover>
          ))
        }
      </ul>
      <div className={styles.btns}>
        <Dropdown
          getPopupContainer={() => document.getElementById('lang') as HTMLElement}
          render={
            <Dropdown.Menu className={styles.langs}>
              <Dropdown.Item onClick={() => changeLang('cn')}>中文</Dropdown.Item>
              <Dropdown.Item onClick={() => changeLang('en')}>English</Dropdown.Item>
            </Dropdown.Menu>
          }
          trigger="click"
        >
          <div id="lang" className={styles.lang}>{router.locale === 'cn' ? '语言：中文' : 'English'}</div>
        </Dropdown>
        <div className={styles.countdown}>
          {t('common.cout')}
          <span>{difference}</span>
          {t('common.day')}
        </div>
      </div>
      <img className={styles.nav} src="/image/menu.png" alt="" onClick={() => setIsShowMenu(!isShowMenu)} />
      <SideSheet title="IPB 2026" placement="left" visible={isShowMenu} width="75%" onCancel={() => setIsShowMenu(!isShowMenu)}>
        <Tree
          treeData={getTreeData(menuList)}
          renderFullLabel={renderFullLabel}
          onSelect={(selectedKey: string, selected: boolean, selectedNode: any) => {
            gotoPage(selectedNode)
          }}
        />
      </SideSheet>
      <style jsx global lang='scss'>
        {
          `
            .semi-portal{
              z-index: 10000 !important;
            }
            .semi-sidesheet-title{
              width: 80%;
            }
            .semi-tree-option{
              padding: 8px 12px !important;
            }
          `
        }
      </style>
    </header>
  );
};
